import styled, { keyframes } from 'styled-components';

const skeletonKeyframes = keyframes`
  0% {
    transform: translateX(-312px);
  }
  100% {
    transform: translateX(calc(312px + 100%));
  }
`;

export const Skeleton = styled.div.attrs({
  tabIndex: 0,
  role: 'progressbar',
  'aria-busy': true,
  'aria-valuemin': 0,
  'aria-valuemax': 100,
})`
  --skeleton-highlight: var(--c-nd-50);
  display: inline-block;
  background-color: rgba(var(--c-rgb-white), 0.05);
  background-size: 312px 100%;
  background-repeat: no-repeat;
  border-radius: var(--half-unit);

  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    will-change: transform;
    animation: ${skeletonKeyframes} 1300ms ease-in-out infinite;
    background: linear-gradient(
      to right,
      transparent,
      var(--skeleton-highlight),
      transparent
    );
  }
`;
